import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { reimbursementSettingsRepository } from '../data-access/repositories/ReimbursementSettingsRepository'

const base = ['reimbursement-settings']

export const reimbursementSettingsQueryConfig = {
  preference: () => ({
    queryKey: buildQueryKey([...base, 'preference']),
    queryFn: () => reimbursementSettingsRepository.get(),
  }),
}
